let lightbox = document.getElementsByClassName('gallery');

if(lightbox.length) {
    let gallery_item = document.getElementsByClassName("gallery--item");
    let body = document.getElementsByTagName('body')[0];
    let modal = document.createElement('div');
    modal.innerHTML = `
        <div class="gallery-modal-content">
            <div class="gallery-modal-close">
                <span class="gallery-modal-close-icon">&times;</span>
            </div>
            <div class="gallery-modal-image">
                <img src="" alt="" class="gallery-modal-img">
                <p class="gallery-modal-label"></p>
            </div>
        </div>
    `;
    body.appendChild(modal);
    let modalClose = document.getElementsByClassName('gallery-modal-close')[0];
    let modalContent = document.getElementsByClassName('gallery-modal-content')[0];
    let modalImage = document.getElementsByClassName('gallery-modal-image')[0];
    let modalImg = document.getElementsByClassName('gallery-modal-img')[0];
    let modalLabel = document.getElementsByClassName('gallery-modal-label')[0];
    let modalCloseIcon = document.getElementsByClassName('gallery-modal-close-icon')[0];

    modal.id = "gallery-modal";
    modal.classList.add(
        "gallery-modal-container",
        "position-fixed",
        "z-index-100",
        "w-100",
        "h-100",
        "overflow-hidden",
        "d-none",
        "flex-column",
        "align-items-center",
        "justify-content-center"
    );
    let modalStyles = {
        inset: 0,
        zIndex: 9999,
        backgroundColor: "rgba(18, 23, 54,0.8)",
    };
	Object.assign(modal.style, modalStyles);
    modalContent.classList.add(
        'container',
        'position-relative'
    );
    modalImage.classList.add("w-75", "m-auto");
    modalImg.classList.add('img-fluid');

    let modalCloseStyles = {
        position: "absolute",
        top: "0",
        right: "0",
        padding: "0.5rem",
        cursor: "pointer"
    };
    Object.assign(modalClose.style, modalCloseStyles);
    let modalCloseBtnStyles = {
        color: "white",
        fontSize: "40px",
        fontWeight: "bold",
    };
    Object.assign(modalCloseIcon.style, modalCloseBtnStyles);

    modalClose.addEventListener('click', () => {
        modal.classList.add('d-none');
        modal.classList.remove('d-flex');
    });
    modalContent.addEventListener('click', (e) => {
        e.stopPropagation();
    });
    modalImage.addEventListener('click', (e) => {
        e.stopPropagation();
    });
    modalCloseIcon.addEventListener('click', (e) => {
        modal.classList.add("d-none");
		modal.classList.remove("d-flex");
    });
    for(let i = 0; i < gallery_item.length; i++) {
        let img = gallery_item[i].getElementsByTagName('img');
        gallery_item[i].addEventListener('click', (e) => {
            e.preventDefault();

            if ($(window).width() >= 768) {
                modal.classList.add("d-flex");
                modal.classList.remove("d-none");
                modalImg.src = img[0].src;
                modalLabel.innerHTML = img[0].alt;
            }
        });
    }
}
